import { useForm, Controller } from "react-hook-form";
import CustomTextInput from "../../ui/CustomTextInput/CustomTextInput";
import CustomButton from "../../ui/CustomButton/CustomButton";
import { requestPasswordResetValidators } from "../../../lib/validations/authValidations";
import AuthLayout from "../authLayout/AuthLayout";
import AuthCard from "../authCard/AuthCard";
import CustomNotificationBanner from "../../ui/CustomNotificationBanner/CustomNotificationBanner";

export default function RequestResetEmail({
  title,
  subtitle,
  buttonLabel = "Submit",
  onSubmit,
  isPending,
  banner,
  onBannerClose,
}) {
  const { control, handleSubmit, watch } = useForm({
    defaultValues: { email: "" },
    mode: "onTouched",
  });

  const email = watch("email");
  const hasFormErrors = Boolean(requestPasswordResetValidators.email(email));

  const submit = (values) => onSubmit(values.email);

  return (
    <AuthLayout>
      <AuthCard
        title={title}
        subtitle={
          <div className="text-black-50 text-xs md:text-sm">{subtitle}</div>
        }
      >
        {banner && (
          <CustomNotificationBanner
            variant={banner.variant}
            title={banner.title}
            message={banner.message}
            mb="md"
            onClose={onBannerClose}
          />
        )}
        <form
          className="flex flex-col gap-2 md:gap-5"
          onSubmit={handleSubmit(submit)}
        >
          <Controller
            name="email"
            control={control}
            rules={{
              validate: (v) => requestPasswordResetValidators.email(v) ?? true,
            }}
            render={({ field, fieldState }) => (
              <CustomTextInput
                label="Email:"
                radius="md"
                type="email"
                disabled={isPending}
                styles={{
                  input: {
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                }}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                error={fieldState.error?.message}
              />
            )}
          />
          <CustomButton
            type="submit"
            radius="xl"
            size="sm"
            fullWidth
            disabled={isPending || hasFormErrors}
            loading={isPending}
          >
            {buttonLabel}
          </CustomButton>
        </form>
      </AuthCard>
    </AuthLayout>
  );
}
